module.exports = __webpack_public_path__ + "img/exit_12.e18c2ae5.svg";